import { CELL_SIZE } from '../../game/content/data';
import type { TowerState, Vec2 } from '../../game/simulation/types';

export const findHoveredTower = (towers: readonly TowerState[], hover: Vec2 | null): TowerState | undefined => {
  if (!hover) return undefined;
  return towers.find((tower) => {
    const left = tower.cell.x * CELL_SIZE;
    const top = tower.cell.y * CELL_SIZE;
    return hover.x >= left && hover.x < left + CELL_SIZE && hover.y >= top && hover.y < top + CELL_SIZE;
  });
};
